export const state = {
  showMasks: false,
  insetMapInitLoad: true
};